<template>
  <div class="overlay">
    <div class="modal">
      <div class="modal__title">
        <span>Session Expired</span>
      </div>
      <div class="p-3">
        <p>You have left this browser idle for 15 minutes.</p>
        <p>{{time}} second left</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      time: 10
    }
  },
  created () {
    let timerId = setInterval(() => {
      this.time -= 1
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId)
      if (this.time < 1) {
        clearInterval(timerId)
        // Your logout function should be over here
        this.$store.commit('NOTIFICATION', ['Session is expired due to inActivity'])
        this.$store.dispatch('USER_LOGOUT')
      }
    }, 1000)
  }
}
</script>
<style lang="postcss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal {
  width: 500px;
  display:block !important;
  box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
  border-radius: 4px;
  z-index: 9999;
  @apply bg-white p-2;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  height: 150px;
  padding: 20px;
}
.modal__title {
  color: #38404f;
  @apply flex items-center justify-between p-3 font-bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalIdle.vue